import React from "react";
import styles from "./Contact.module.css";
import { projects } from "../../data/projectsData";

export const Contact = () => {
  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Contact Section */}
        <div className={styles.section}>
          <h4>Contact Us</h4>
          <p>📞 Phone: +91 9351350410</p>
          <p>📞 Phone: +91 9460786561</p>
          <p>📧 Email: vijay.g1977@rediffmail.com</p>
        </div>

        {/* Address Section */}
        <div className={styles.section}>
          <h4>Address</h4>
          <p>
            Adarsh Industries, H-1-44, Udyog Vihar, Sikar Road, Near Chomu,
            Jaitpura, Jaipur.
          </p>
        </div>

        {/* Product Links Section */}
        <div className={styles.section}>
          <h4>Our Products</h4>
          <ul>
            {otherProducts.map((product) => {
              return (
                <li>
                  <a href={`/products/${product.id}`}>{product.title}</a>
                </li>
              );
            })}
            {/* <li>
              <a href="/products/Himalya-diamond-pellets">Product 1</a>
            </li>
            <li>
              <a href="/products/Gopalan-diamond-pellets">Product 2</a>
            </li>
            <li>
              <a href="/product3">Product 3</a>
            </li> */}
          </ul>
        </div>

        {/* Location Section */}
        <div className={styles.section}>
          <h4>Our Location</h4>
          <iframe
            className={styles.map}
            // src="https://maps.google.com/maps?q=27.1213915%2C75.7343471&z=17&hl=en"

            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11627.622429654632!2d75.7343471!3d27.1213915!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z27.1213915%2C75.7343471!5e0!3m2!1sen!2sin!4v1699076922900!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            title="Our Location"
          ></iframe>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>© 2024 Your Company Name. All Rights Reserved.</p>
      </div>
    </footer>
  );
};
